import RemoveIcon from '@mui/icons-material/Remove';
import { useTranslation } from 'react-i18next';

import { StyledFab, StyledButtonContainer } from '../../styles/input-row';

interface RemoveRowButtonProps {
    index: number;
    removeRow: (index: number) => void;
}

const RemoveRowButton: React.FC<RemoveRowButtonProps> = ({ index, removeRow }) => {
    const { t } = useTranslation('generic');

    return (
        <StyledButtonContainer>
            <StyledFab color="secondary" aria-label={t('remove-row')} onClick={() => removeRow(index)}>
                <RemoveIcon />
            </StyledFab>
        </StyledButtonContainer>
    );
};

export default RemoveRowButton;
